import WalletUser from "./wallet-user.page";

export default WalletUser;
